// Routes
export const ROUTES = {
  HOME: "/",
};

// Types
export interface Feature {
  id: string;
  icon: string;
  title: string;
  subtitle: string;
  desc: string;
  color: string;
}

export interface Stat {
  value: string;
  label: string;
  suffix?: string;
}

export interface Testimonial {
  id: number;
  avatar: string;
  name: string;
  role: string;
  content: string;
  stars: number;
}

export interface Spec {
  label: string;
  value: string;
}

// Data
export const STATS: Stat[] = [
  { value: "10", label: "万+全球用户", suffix: "万" },
  { value: "1500", label: "万次累计交互", suffix: "万" },
  { value: "8", label: "小时日均佩戴时长", suffix: "h+" },
  { value: "200", label: "次持续软件更新", suffix: "+" },
];

export const FEATURES: Feature[] = [
  {
    id: "translate",
    icon: "🌐",
    title: "实时翻译",
    subtitle: "打破语言壁垒",
    desc: "支持12+语言实时翻译，字幕直接显示在你眼前。商务谈判、海外旅行、跨国沟通，零障碍交流从此成为日常。",
    color: "from-emerald-500/20 to-teal-500/10",
  },
  {
    id: "navigate",
    icon: "🗺️",
    title: "智能导航",
    subtitle: "抬头看路不低头",
    desc: "高德地图联动，导航信息直接投影在视野中。骑行、驾车、步行，双手解放，眼前就是路线指引。",
    color: "from-blue-500/20 to-cyan-500/10",
  },
  {
    id: "teleprompter",
    icon: "🎤",
    title: "提词器",
    subtitle: "演讲从容不慌张",
    desc: "视野内显示文稿内容，公开演讲、活动主持、培训授课，自信开口，告别磕绊。",
    color: "from-purple-500/20 to-pink-500/10",
  },
  {
    id: "camera",
    icon: "📷",
    title: "第一视角拍摄",
    subtitle: "记录真实生活瞬间",
    desc: "1200万高清摄像头，以你的视角记录世界。一键拍摄，无需掏手机，Vlog、探店、旅途，每个精彩瞬间不再错过。",
    color: "from-orange-500/20 to-amber-500/10",
  },
  {
    id: "ai",
    icon: "🤖",
    title: "AI 语音助理",
    subtitle: "随时唤醒你的智能伙伴",
    desc: "集成千问大模型、ChatGPT、Gemini，语音唤醒即可查询信息、设置提醒、控制智能家居，AI 助理始终在线。",
    color: "from-primary/20 to-accent/10",
  },
  {
    id: "health",
    icon: "💡",
    title: "信息随叫随到",
    subtitle: "零学习成本上手",
    desc: "通知提醒、天气、音乐控制……所有日常信息一抬眼即可获取。无需低头，无需掏手机，生活更流畅。",
    color: "from-red-500/20 to-rose-500/10",
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    avatar: "张",
    name: "张先生",
    role: "外贸业务员",
    content: "和海外客户开会再也不怕了！实时翻译字幕就显示在眼前，对方说什么我都能第一时间理解，成单率提升了不少。",
    stars: 5,
  },
  {
    id: 2,
    avatar: "李",
    name: "李女士",
    role: "旅游博主",
    content: "第一视角拍摄真的太方便了！边骑车边拍，双手不用动，拍出来的视角超级真实，粉丝都说感觉像亲临其境。",
    stars: 5,
  },
  {
    id: 3,
    avatar: "王",
    name: "王老师",
    role: "大学讲师",
    content: "讲课的时候偷偷用提词器，再也不用担心忘词了。关键是看起来完全自然，学生根本看不出来，自信心爆棚！",
    stars: 5,
  },
  {
    id: 4,
    avatar: "陈",
    name: "陈同学",
    role: "大学生",
    content: "去日本交流学习，实时翻译救了我！路牌、菜单、聊天全靠它，日语不好也能玩转全程，完全不慌。",
    stars: 5,
  },
];

export const SPECS: Spec[] = [
  { label: "摄像头", value: "1200万像素" },
  { label: "支持语言", value: "12+ 种语言" },
  { label: "日均续航", value: "8小时以上" },
  { label: "软件更新", value: "200+ 次迭代" },
  { label: "全球用户", value: "10万+ 五大洲" },
  { label: "合作门店", value: "1200+ 线下体验" },
  { label: "质保服务", value: "1年整机质保" },
  { label: "Rokid Care 碎屏险", value: "¥199/年 · ¥299/两年" },
  { label: "AI 能力", value: "千问 + ChatGPT + Gemini" },
];

export const NAV_ITEMS = [
  { label: "产品特色", href: "#features" },
  { label: "使用场景", href: "#scenarios" },
  { label: "用户评价", href: "#testimonials" },
  { label: "规格参数", href: "#specs" },
  { label: "购买", href: "#buy" },
];
